import React, { useEffect, useState } from 'react';
import MuiTable from '../../../components/MuiTable/MuiTable';
import SearchInput from '../../../components/SearchInput/SearchInput';
import MultipleFilter from '../../../components/MultipleFilter/MultipleFilter';
import { colors } from '../../../config/constants';
import {
  updateFlashBar,
  updateIsLoading,
  updateReviewCategoryCount,
  updateReviewTab,
} from '../../../redux/action';
import instance from '../../../service/axiosInstane';
import { useDispatch, useSelector } from 'react-redux';
import { flashBarTheme } from '../../../config/flashBar';
import qs from 'qs';
import { SortOrderType } from '../../../config/enum';
import { StateProps } from '../../../redux/reducer';
import { totalPages } from '../../../config/helpers';

const catColumns = [
  { id: 'categoryName', label: 'Category Name', minWidth: 150, align: 'left' },
  { id: 'categoryLabelName', label: 'Label', minWidth: 100, align: 'left' },
  { id: 'keywordCount', label: 'Keyword Count', minWidth: 150, align: 'center' },
  { id: 'hitCount', label: 'Hit Count', minWidth: 100, align: 'center' },
  { id: 'totalDmcaMarked', label: 'DMCA Marked', minWidth: 150, align: 'center' },
  { id: 'reviewPercentage', label: 'Review Status', minWidth: 150, align: 'center' },
  { id: 'categoryAction', label: 'Action', minWidth: 0, align: 'right' },
];

type WebsiteCategoryProps = {
  siteOrgIndexId: string;
};

type CategoryProps = {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  results?: ResultProps[];
};

type RequestProps = {
  CategoryLabel: string[];
  Page: number;
  PageSize: number;
  SearchText: string;
  SortBy: string;
  SortOrder: string;
};

type ResultProps = {
  categoryId: string;
  categoryLabelId: string;
  categoryLabelName: string;
  categoryName: string;
  hitCount: number;
  keywordCount: number;
  reviewPercentage: number;
};

type ReviewProps = {
  reviewStatus: number;
  siteUrl: string;
  siteHost: string;
  siteId: string;
  organizationId: string;
  siteOrganizationId: string;
  siteOrganizationIndexId: string;
};

const WebsiteCategory = (props: WebsiteCategoryProps) => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const reviewTab = useSelector((state: StateProps) => state.reviewTab);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [reviewState, setReviewState] = useState<ReviewProps>({
    reviewStatus: 0,
    siteUrl: '',
    siteHost: '',
    siteId: '',
    organizationId: '',
    siteOrganizationId: '',
    siteOrganizationIndexId: '',
  });
  const [categoryRequest, setRequestCategory] = useState<RequestProps>({
    CategoryLabel: [],
    Page: page,
    PageSize: limit,
    SearchText: '',
    SortBy: 'hitCount',
    SortOrder: SortOrderType.DESC,
  });
  const [categoryState, setCategoryState] = useState<ResultProps[]>([]);
  const [categoryLabel, setCategoryLable] = useState([]);

  const catLabel = [
    {
      Heading: 'Category Label',
      data: categoryLabel,
    },
  ];

  useEffect(() => {
    if (props.siteOrgIndexId !== undefined) {
      getSiteOrgReview();
      getReviewCategories(categoryRequest);
      getCategoryLable();
    }
  }, []);

  const viewRecordCategory = (row: ResultProps) => {
    dispatch(
      updateReviewTab({
        ...reviewTab,
        tabName: 'keyword',
        siteOrgIndexID: props.siteOrgIndexId,
        categoryID: row.categoryId,
        keywordID: '',
      })
    );
  };

  const getSiteOrgReview = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get(`site-review/site-organization-index/${props.siteOrgIndexId}/review`)
      .then((response) => {
        if (response.status === 200) {
          setReviewState(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const getReviewCategories = async (obj: RequestProps) => {
    dispatch(updateIsLoading(true));
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `site-review/site-organization-index/${props.siteOrgIndexId}/categories?${queryString}`;
    await instance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotResponse = (data: CategoryProps) => {
    setCategoryState(data?.results as ResultProps[]);
    setTotalRowCount(data.totalCount);
    dispatch(updateReviewCategoryCount(data.totalCount));
    dispatch(updateIsLoading(false));
  };

  const searchHandler = () => {
    getReviewCategories({
      ...categoryRequest,
      SearchText: categoryRequest.SearchText,
      PageSize: limit,
    });
  };

  const onSearchHandler = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setRequestCategory({ ...categoryRequest, SearchText: e.target.value });
  };

  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchHandler();
    }
  };

  const onClearSearch = () => {
    setRequestCategory({
      ...categoryRequest,
      SearchText: '',
      Page: page,
      PageSize: limit,
    });
    getReviewCategories({
      ...categoryRequest,
      SearchText: '',
      Page: page,
      PageSize: limit,
    });
  };

  const filterHandler = (arg: any) => {
    getReviewCategories({
      ...categoryRequest,
      SortOrder: categoryRequest.SortOrder,
      SortBy: categoryRequest.SortBy,
      Page: 1,
      PageSize: limit,
      CategoryLabel: arg[0]?.selectedMenu,
    });
    setRequestCategory({
      ...categoryRequest,
      CategoryLabel: arg[0]?.selectedMenu,
    });
    setPage(1);
  };

  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getReviewCategories({ ...categoryRequest, Page: page, PageSize: limit });
      setPage(page);
    },
    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getReviewCategories({
          ...categoryRequest,
          Page: page + 1,
          PageSize: limit,
          CategoryLabel: categoryRequest.CategoryLabel,
        });
        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getReviewCategories({
          ...categoryRequest,
          Page: page - 1,
          PageSize: limit,
          CategoryLabel: categoryRequest.CategoryLabel,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getReviewCategories({
          ...categoryRequest,
          Page: 1,
          PageSize: limit,
          CategoryLabel: categoryRequest.CategoryLabel,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getReviewCategories({
          ...categoryRequest,
          Page: totalPages(totalRowCount, limit),
          PageSize: limit,
          CategoryLabel: categoryRequest.CategoryLabel,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },

    limitHandler: (item: number) => {
      getReviewCategories({
        ...categoryRequest,
        Page: 1,
        PageSize: item,
        CategoryLabel: categoryRequest.CategoryLabel,
      });
      setLimit(item);
      setPage(1);
    },
  };

  const sorting = (sortOrder: string) => {
    let temp = '';
    if (sortOrder == SortOrderType.DESC) {
      temp = SortOrderType.ASC;
    } else {
      temp = SortOrderType.DESC;
    }
    setRequestCategory({ ...categoryRequest, SortOrder: temp });
    return temp;
  };

  const sortRecord = (fieldName: string, SortOrder: string) => {
    getReviewCategories({
      ...categoryRequest,
      SortOrder: sorting(SortOrder),
      SortBy: fieldName,
      Page: page,
      PageSize: limit,
      SearchText: categoryRequest.SearchText,
    });
    getReviewCategories({
      ...categoryRequest,
      SortBy: fieldName,
      SortOrder: sorting(SortOrder),
    });
  };

  const getCategoryLable = () => {
    instance
      .get(`/category-labels?organizationId=${userInfo.organizationId}`)
      .then((response) => {
        if (response.status === 200) {
          setCategoryLable(response.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="bg-white rounded-sm mx-2 p-2">
      <div className="text-black">
        <div className="sm:flex sm:flex-col sm:items-start lg:flex-row lg:items-center justify-between w-full text-sm">
          <div className="flex items-center space-x-2 ">
            <div>Webiste :</div>
            <a
              target="_blank"
              rel="noreferrer"
              href={`${reviewState.siteUrl}`}
              className="text-blue-500 cursor-pointer"
            >
              {reviewState.siteHost}
            </a>
          </div>
          <div className="flex items-center space-x-2">
            <div>Review Status </div>
            <div className="mt-1 flex items-center space-x-2">
              <div className="h-4 w-[150px] border rounded-sm">
                <div
                  style={{ width: `${reviewState.reviewStatus * 1.5}px` }}
                  className={`h-4 bg-green-600 rounded-sm`}
                ></div>
              </div>
              <div>{Math.round(reviewState.reviewStatus)}% </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-1 ">
        <div className={`font-semibold text-[18px] ${colors.primaryText}`}>
          Category Management
        </div>
        <div className="w-full sm:flex sm:flex-col sm:items-start lg:flex-row lg:items-center justify-between px-2 border py-1 rounded-md bg-slate-50 mt-1">
          <div className="sm:py-2 lg:pb-0">
            <SearchInput
              value={categoryRequest.SearchText}
              onChange={onSearchHandler}
              onSearch={searchHandler}
              onClear={() => onClearSearch()}
              handleEnterKeyPress={handleEnterKeyPress}
            />
          </div>
          <div className="mt-4 sm:mt-0 sm:pb-2 lg:pb-0">
            <MultipleFilter filterHandler={filterHandler} rootFilter={catLabel} />
          </div>
        </div>
        <div className="mt-2">
          <MuiTable
            columns={catColumns}
            rows={categoryState}
            showView={true}
            onViewHandler={viewRecordCategory}
            page={page}
            limit={limit}
            paginateHandler={paginateHandler}
            totalRowCount={totalRowCount}
            onSortHandler={sortRecord}
            sortOrder={categoryRequest.SortOrder}
            sortArray={['hitCount', 'reviewStatus', 'keywordCount']}
          />
        </div>
      </div>
    </div>
  );
};

export default WebsiteCategory;
